import styled from 'styled-components';

import colors from 'shared-assets/lib/colors';

import AComponent from './A';
import ButtonComponent from './Button';
import InputComponent from './Input';
import LabelComponent from './Label';
import SelectComponent from './Select';

export const A = AComponent;

export const Button = ButtonComponent;

export const H1 = styled.h1`
  &&& {
    color: ${colors.textColorPrimary};
    display: block;
    font-size: 1.75rem;
    font-weight: 600;
    line-height: 1.75rem;
    margin: 0;
    padding: 1.5rem 0;
  }
`;

export const H2 = styled.h2`
  && {
    font-weight: 600;
    font-size: 1.5rem;
    margin: 0;
    padding: 0;
  }
`;

export const H3 = styled.h3`
  && {
    font-weight: 600;
    font-size: 1.175em;
    margin: 0;
    padding: 0;
  }
`;

export const H4 = styled.h4`
  && {
    font-weight: 600;
    font-size: 1rem;
    color: ${colors.textColorPrimary};
    margin: 0;
  }
`;

export const HR = styled.hr`
  border: 0;
  height: 0;
  border-top: none;
  border-bottom: 1px solid rgba(${colors.secondaryRGB.join(', ')}, 0.12);
  margin: 1rem 0;
`;

export const P = styled.p`
  color: ${props => (!!props.color ? props.color : colors.lightText)};
  margin-top: 0.3125rem;
  margin-bottom: 0.625rem;
  padding: 0 1rem;
`;

export const Input = InputComponent;

export const Label = LabelComponent;

export const Select = SelectComponent;
